import { Component, OnInit } from '@angular/core';
import { HeaderService } from '@core/services/header.service';
import { PermissionService } from '@core/services/permission.service';

interface MdTab {
  key: string;
  label: string;
  icon: string;
  ready: boolean;
}

@Component({
  standalone: false,
  selector: 'app-master-data',
  templateUrl: './master-data.component.html',
  styleUrls: ['./master-data.component.scss']
})
export class MasterDataComponent implements OnInit {
  private readonly allTabs: MdTab[] = [
    { key: 'designations', label: 'Designations', icon: 'badge',         ready: true  },
    { key: 'roles',        label: 'Roles',        icon: 'admin_panel_settings', ready: true },
    { key: 'users',        label: 'Users',        icon: 'group',         ready: true  },
    { key: 'exceptions',   label: 'Exceptions',   icon: 'visibility_off', ready: true  },
    { key: 'automation',   label: 'Automation',   icon: 'bolt',          ready: true  },
  ];
  activeTab = 'designations';

  constructor(private headerService: HeaderService, private perms: PermissionService) {}

  get tabs(): MdTab[] {
    return this.allTabs.filter(t => this.perms.canViewTab('master_data', t.key));
  }

  ngOnInit(): void {
    this.headerService.setTitle('Master Data');
    const visible = this.tabs;
    if (visible.length && !visible.some(t => t.key === this.activeTab)) {
      this.activeTab = visible[0].key;
    }
  }

  selectTab(key: string): void {
    this.activeTab = key;
  }
}
